import React, { useState } from 'react';

const OTPForm = ({ verifyOTP }) => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    // Focus next input
    if (element.value !== '' && index < 5) {
      const nextInput = element.parentElement.nextElementSibling.querySelector('input');
      nextInput.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otpString = otp.join('');
    if (otpString.length === 6) {
      verifyOTP(otpString);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="d-flex justify-content-center gap-2 mb-4">
        {otp.map((data, index) => (
          <div key={index}>
            <input
              type="text"
              maxLength="1"
              className="form-control text-center"
              style={{ width: '45px', height: '45px' }}
              value={data}
              onChange={e => handleChange(e.target, index)}
              onFocus={e => e.target.select()}
            />
          </div>
        ))}
      </div>
      
      <button 
        type="submit" 
        className="btn btn-primary w-100"
        disabled={otp.join('').length !== 6}
      >
        Verify OTP
      </button>
    </form>
  );
};

export default OTPForm; 